import datapoints from '../datapoints';
import reportMessageToSafetyLibraryService from 'owa-mail-triage-action/lib/services/reportMessageToSafetyLibraryService';
import { action } from 'satcheljs/lib/legacy';
/**
 * The action which marks items as phishing.
 * @param itemIds - the itemIds to mark as phishing * @param actionSource - where this mark as phishing action is triggered
 * @param markAsPhishingStoreUpdate the callback function to update the store upon markItemsAsPhishingDatapoint as phishing
 * @returns a promise to end the markItemsAsPhishingDatapoint datapoint
 */
export default action('markItemsAsPhishing', datapoints.markItemsAsPhishingDatapoint)(function markItemsAsPhishingBasedOnItemIds(itemIds, actionSource, markAsPhishingStoreUpdate) {
    try {
        reportMessageToSafetyLibraryService(itemIds, 3 /* Phish */);
    }
    catch (error) {
        // VSO 19006: Handle service error caused by block
    }
    markAsPhishingStoreUpdate();
    // Synchronously returns the promise to end the markItemsAsPhishingDatapoint datapoint
    return Promise.resolve();
});
//# sourceMappingURL=markItemsAsPhishingBasedOnItemIds.js.map